var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconLiquidity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#ADADD0",
    strokeWidth: 1.5,
    fill: "none",
    fillRule: "evenodd",
    strokeDasharray: "0,0",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.599,
    d: "M2.093 8.404h17.824"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.442 12.31h.01m-4.447 0h.009m-4.456 0h.01m8.874 3.886h.01m-4.447 0h.009m-4.456 0h.01",
    opacity: 0.597
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.044 1v3.291M6.966 1v3.291M6.771 2.58C3.834 2.58 2 4.214 2 7.221v9.05C2 19.326 3.834 21 6.771 21h8.458C18.175 21 20 19.355 20 16.348V7.222c.01-3.007-1.816-4.643-4.762-4.643H6.771z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLiquidity);
export default __webpack_public_path__ + "static/media/icon-liquidity.790c8c4038d2ddcc83372ac0977ec7f1.svg";
export { ForwardRef as ReactComponent };